import { faker } from '@faker-js/faker';
import { define, Factory } from 'cooky-cutter';
import { Device, SerialNumber } from '../types';

export const serialNumberFactory: Factory<SerialNumber> = define<SerialNumber>({
  id: () => faker.string.uuid(),
  externalId: () => faker.string.numeric({ length: 10 }),
  number: () => faker.string.alphanumeric({ length: 14 }).toUpperCase(),
  device: () => ({} as Device),
});
